import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getDoneWorksAllLogisticWorks(options = {}) {
  return _apiRequestWrap(
    ModulesMap.DONE_WORKS_ALL_LOGISTIC_WORKS,
    ModulesConfigMap[ModulesMap.DONE_WORKS_ALL_LOGISTIC_WORKS].GET_DONE_WORKS_ALL_LOGISTIC_WORKS,
    options
  )
}

export default {
  [ModulesConfigMap[ModulesMap.DONE_WORKS_ALL_LOGISTIC_WORKS].GET_DONE_WORKS_ALL_LOGISTIC_WORKS]: _getDoneWorksAllLogisticWorks
}